module.exports = __webpack_public_path__ + "static/media/ic_modal_open.ad0000ed.svg";